import React from 'react';
import { BiArrowToBottom } from 'react-icons/bi';
import { useMonitor } from '../../../hooks/newMonitor';
import * as S from './styles';

const LoadMore: React.FC = () => {
  const { isLoading, listOrders, handleChangePage } = useMonitor();

  return (
    <S.Container>
      {(listOrders !== null && listOrders.currentPage < listOrders.totalPages && !isLoading) && (
        <div>
          <button onClick={handleChangePage}>
            Carregar mais
            <BiArrowToBottom size={16} />
          </button>
        </div>
      )}
    </S.Container>
  );
};

export default LoadMore;
